import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetResultsGroupedByYear = organizationId => {
  const query = useApiQuery(
    ['results-grouped-by-year', organizationId],
    'sociogram',
    `/results/group-by-year?organizationId=${organizationId}`,
    { enabled: !!organizationId }
  )

  return {
    isLoadingResults: query.isLoading,
    isFetchingResults: query.isFetching,
    results: query.data ?? {},
    errorResults: query.isError ? query.error : null,
    fetchResults: query.refetch
  }
}
